<div class="bg-blue-gradient">
    <i class="icon-bar-ups d-none d-md-block"></i>
    <i class="icon-mountain d-none d-md-block"></i>
    <i class="icon-row-up d-none d-md-block"></i>

    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-9 pt-3 pb-4" *ngIf="!showResume">
                <p class="mat-title" [innerHTML]="'test.suitability.description' | translate"></p>
            </div>

            <ng-container *ngIf="showResume">
                <div class="col-12 col-lg-10 pt-3">
                    <p class="text-blue" [innerHTML]="'test.resume.description' | translate"></p>
                </div>

                <ng-container
                    [ngTemplateOutlet]="resumeTmpl"
                    [ngTemplateOutletContext]="{
                        questions: result.questions,
                        from: 0,
                        to: 7
                    }"
                ></ng-container>
            </ng-container>
        </div>
    </div>
</div>

<ng-container *ngIf="showResume && fullResume && result">
    <div class="mt-4">
        <ng-container
            [ngTemplateOutlet]="resumeTitleTmpl"
            [ngTemplateOutletContext]="{
                title: 'test.suitability.title-block-2' | translate
            }"
        ></ng-container>
    </div>
    <div class="bg-blue-gradient">
        <i class="icon-bar-ups d-none d-md-block"></i>
        <i class="icon-mountain d-none d-md-block"></i>
        <i class="icon-row-up d-none d-md-block"></i>

        <div class="container">
            <div class="row">
                <ng-container
                    [ngTemplateOutlet]="resumeTmpl"
                    [ngTemplateOutletContext]="{
                        questions: result.questions,
                        from: 7,
                        to: 11
                    }"
                ></ng-container>
            </div>
        </div>
    </div>

    <div class="mt-4">
        <ng-container
            [ngTemplateOutlet]="resumeTitleTmpl"
            [ngTemplateOutletContext]="{
                title: 'test.suitability.title-block-3' | translate
            }"
        ></ng-container>
    </div>
    <div class="bg-blue-gradient">
        <i class="icon-bar-ups d-none d-md-block"></i>
        <i class="icon-mountain d-none d-md-block"></i>
        <i class="icon-row-up d-none d-md-block"></i>

        <div class="container">
            <div class="row">
                <ng-container
                    [ngTemplateOutlet]="resumeTmpl"
                    [ngTemplateOutletContext]="{
                        questions: result.questions,
                        from: 11,
                        to: 99
                    }"
                ></ng-container>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #resumeTitleTmpl let-title="title">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="row flex-nowrap justify-content-between align-items-end">
                    <div class="col-auto flex-shrink-1">
                        <h1 class="text-blue mat-display-1 font-weight-bold" [innerHTML]="title"></h1>
                    </div>
                    <div class="col-auto">
                        <i class="icon-test-natural text-blue"></i>
                    </div>
                </div>
                <hr class="mt-1 mb-0" />
            </div>
        </div>
    </div>
</ng-template>

<ng-template #resumeTmpl let-questions="questions" let-from="from" let-to="to">
    <div class="col-12" *ngIf="questions">
        <ng-template ngFor let-question [ngForOf]="questions" let-i="index">
            <div class="row flex-nowrap align-items-start py-4" *ngIf="i >= from && i < to">
                <div class="col-auto">
                    <label class="number">{{ i + 1 }}</label>
                </div>
                <div class="col-auto flex-shrink-1">
                    <p class="text-blue mt-2">{{ question.description }}</p>

                    <ng-template ngFor let-group [ngForOf]="question.groups" let-j="index">
                        <p>
                            {{ i + 1 }}.{{ j + 1 }}. {{ group.description }}:

                            <ng-template ngFor let-option [ngForOf]="group.options">
                                <strong> {{ option.description }}</strong>
                            </ng-template>
                        </p>
                    </ng-template>

                    <ng-template ngFor let-option [ngForOf]="question.options">
                        <p>
                            <strong>{{ option.description }}</strong>
                        </p>
                    </ng-template>
                </div>
            </div>
        </ng-template>
    </div>
</ng-template>

<div class="container">
    <div class="row mt-5 mb-4" [class.justify-content-end]="!showCancelButton" [class.justify-content-between]="showCancelButton">
        <div class="col-12 col-sm-6 col-md-4" *ngIf="showResume">
            <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" (click)="onRepeat()">
                {{ 'test.resume.repeat' | translate }}
            </button>
        </div>
        <div class="col-12 col-sm-6 col-md-4" *ngIf="showCancelButton">
            <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" (click)="onCancel()">
                {{ 'general.cancel' | translate }}
            </button>
        </div>
        <div class="col-12 col-sm-6 col-md-4 mt-3 mt-sm-0">
            <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" (click)="onClick()">
                {{ 'general.continue' | translate }}
            </button>
        </div>
    </div>
</div>
